import * as types from './AuthTypes';

import { all, call, put, select, takeEvery } from "redux-saga/effects";
import {
  refreshTokenCompletedAction,
  refreshTokenFailedAction,
  signInCompletedAction,
  signInFailedAction,
} from "./AuthAction";

import { BaseAction } from "../Common/CommonModel";
import { apiRefreshToken, apiSignIn } from "./AuthApis";

import { creatingNotification } from "../../utils";
import { enqueueSnackbar } from "../Snackbar/SnackbarAction";

export function* watchAuthStart() {
  yield takeEvery(types.SIGN_IN_START, signIn);
}

export function* watchSessionRefresh() {
  yield takeEvery(types.REFRESH_TOKEN_START, refreshToken);
}

function* refreshToken() {
  try {
    const auth: { isAuthenticated: boolean; accessToken: string } = yield select(
      (state: any) => state.auth
    );
    if (!auth.isAuthenticated || !auth.accessToken) {
      yield put(refreshTokenFailedAction());
      return;
    }

    const previousToken = auth.accessToken;
    const response = yield call(apiRefreshToken);
    if (response.status !== 200 || !response.data.token) {
      throw new Error("Token refresh failed");
    }
    yield put(refreshTokenCompletedAction(response.data.token, previousToken));
  } catch (_error) {
    // Ошибка 401 отдельно обрабатывается interceptor-ом API и завершает вход.
    // При временной сетевой ошибке сохраняем текущий токен и повторим позже.
    yield put(refreshTokenFailedAction());
  }
}

function* signIn(action: BaseAction) {
  try {
      const { resp } = yield all({
          resp: call(apiSignIn, action.payload),
      });
      
      if (resp.status !== 200) {
          throw new Error();
      }

      yield put(signInCompletedAction(resp.data.token, resp.data.is_admin));
  } catch (e) {
      yield put(signInFailedAction());

      const errorNotification = creatingNotification(
          "Проверьте правильность ввода логина/пароля.",
          "error"
      );
      yield put(enqueueSnackbar(errorNotification));
  }
}
